import { render, staticRenderFns } from "./AllocatedBackorderHistoryGrid.vue?vue&type=template&id=360fcecc&"
import script from "./AllocatedBackorderHistoryGrid.vue?vue&type=script&lang=js&"
export * from "./AllocatedBackorderHistoryGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports